import { FC } from "react";

import { BookingStatusCell } from "../../grid";
import { IRenderColumnTemplate } from "./_core";

export const BookingStatusCellTemplate: FC<IRenderColumnTemplate> = ({
  value,
}) => {
  return <BookingStatusCell status={value}></BookingStatusCell>;
};
